import { CodeNameEntity } from "../common/code-name-entity";
import { EmployeeResource } from "./employee-resource";

export class EmployeeRoom {
    id: number;
    room: CodeNameEntity;
    employee: EmployeeResource;
    state: any;


    constructor (id: number, room: CodeNameEntity, employee: EmployeeResource) {
        this.id = id;
        this.room = room;
        this.employee = employee;
    }
}
